import { useReducer, useMemo } from 'react';

type Params = {
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  page: number;
  limit: number;
  search?: string;
  storeId: string;
  userId: string;
  orderId?: string;
  status?: string;
  fromDate?: string;
  toDate?: string;
  userType: 'Merchant' | 'Customer' | 'Admin';
  // Filter by order mode - "normal" for immediate orders, "preOrder" for scheduled orders
  orderMode?: 'normal' | 'preOrder';
};

const getInitialParams = (): Params => {
  const userData = JSON.parse(localStorage.getItem('userData') || '{}');
  const storeId = userData?.userDetails?.storeId || '';
  // const merchantId = userData?.userDetails?.storeId || '';
  const userId = userData?.userId || '';

  return {
    sortBy: undefined,
    sortOrder:undefined,
    page: 1,
    limit: 10,
    search: undefined,
    storeId,
    status: undefined,
    userId,
    orderId: undefined,
    fromDate: undefined,
    toDate: undefined,
    userType:'Merchant',
    orderMode: undefined,
  };
};


type Action =
  | { type: 'SET_SEARCH'; payload: string | undefined }
  | { type: 'SET_PAGE'; payload: number }
  | { type: 'SET_LIMIT'; payload: number }
  | { type: 'SET_SORT'; payload: { sortBy: string; sortOrder: 'asc' | 'desc' } }
  | { type: 'SET_FILTERS'; payload: Partial<Params>; resetPage?: boolean }
  | { type: 'RESET' };

function reducer(state: Params, action: Action): Params {
  switch (action.type) {
    case 'SET_SEARCH':
      return { ...state, search: action.payload };
    case 'SET_PAGE':
      return state.page === action.payload ? state : { ...state, page: action.payload };
    case 'SET_LIMIT':
      return { ...state, limit: action.payload};
    case 'SET_SORT':
      return {
        ...state,
        sortBy: action.payload.sortBy,
        sortOrder: action.payload.sortOrder,
      };

      case 'SET_FILTERS':
      return {
        ...state,
        ...Object.fromEntries(
          Object.entries(action.payload).map(([key, val]) => [key, val === '' ? undefined : val])
        ),
      };
    case 'RESET':
      return getInitialParams();
    default:
      return state;
  }
}

export function orderManagementParams() {
  const [params, dispatch] = useReducer(reducer, getInitialParams());

  const stableParams = useMemo(() => params, [
    params.sortBy,
    params.sortOrder,
    params.page,
    params.limit,
    params.search,
    params.storeId,
    params.status,
    params.orderId,
    params.fromDate,
    params.toDate,
    params.userId,
    params.userType,
    params.orderMode,
  ]);

  return { params: stableParams, dispatch };
}
